module.exports = __webpack_public_path__ + "static/flags/SU-6f00b63c35872001c5c9ad8603c582c0.gif";